/**
 * ThemeToggle.tsx — T-156 (BEAD-0063) small header control that cycles the theme choice
 * System → Light → Dark. 'System' follows prefers-color-scheme and live-updates; Light/Dark
 * are persisted overrides (see lib/theme.ts). Icon + accessible label reflect the current choice.
 */
import { useState } from 'react'
import { Monitor, Sun, Moon, type LucideIcon } from 'lucide-react'
import { getStoredChoice, setThemeChoice, type ThemeChoice } from '@/lib/theme'

const ORDER: ThemeChoice[] = ['system', 'light', 'dark']

const META: Record<ThemeChoice, { Icon: LucideIcon; label: string }> = {
  system: { Icon: Monitor, label: 'Theme: system — click for light' },
  light: { Icon: Sun, label: 'Theme: light — click for dark' },
  dark: { Icon: Moon, label: 'Theme: dark — click for system' },
}

export function ThemeToggle() {
  const [choice, setChoice] = useState<ThemeChoice>(() => getStoredChoice())
  const { Icon, label } = META[choice]

  function cycle() {
    const next = ORDER[(ORDER.indexOf(choice) + 1) % ORDER.length]!
    setThemeChoice(next)
    setChoice(next)
  }

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={label}
      title={label}
      className="flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground
                 hover:bg-accent hover:text-accent-foreground focus-visible:outline-none
                 focus-visible:ring-2 focus-visible:ring-ring transition-colors"
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
    </button>
  )
}
